import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mainFormContainer: {
    margin: theme.spacing(10, 0),
  },
  sectionText: {
    margin: 0,
    '& a': {
      color: theme.palette.text.primary,
      textDecoration: 'none',
    },
  },
  section: {
    marginBottom: theme.spacing(24),
  },
  sectionHeading: {
    marginBottom: theme.spacing(2),
  },
  branchWrapper: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  branchDescription: {
    color: theme.palette.text.lightGrey,
  },
  [theme.breakpoints.down('xs')]: {
    bannerContainer: {
      padding: theme.spacing(0),
    },
    contactSidebar: {
      paddingRight: theme.spacing(0),
    },
    contactFormSection: {
      marginTop: theme.spacing(5),
      padding: theme.spacing(0),
    },
  },
  [theme.breakpoints.up('sm')]: {
    mainFormContainer: {
      padding: theme.spacing(0, 16),
    },
    contactSidebar: {
      paddingRight: theme.spacing(0),
    },
    contactFormSection: {
      marginTop: theme.spacing(5),
      padding: theme.spacing(0),
    },
  },
  [theme.breakpoints.up('md')]: {
    contactSidebar: {
      paddingRight: theme.spacing(5),
    },
    contactFormSection: {
      marginTop: theme.spacing(0),
      padding: theme.spacing(0),
    },
    mainFormContainer: {
      padding: theme.spacing(0, 12, 0, 17),
    },
  },
}))
